export const adminCommissions = {
  "admin.commissions.pageTitle": "Gestione delle Commissioni",
  "admin.commissions.pageDescription": "Gestire e visualizzare tutti i dati delle commissioni nel sistema",

  // Tracker page translations
  "admin.commissions.tracker.title": "Tracciamento Commissioni",
  "admin.commissions.tracker.subtitle": "Tracciamento dettagliato di tutte le attività e transazioni delle commissioni",
  "admin.commissions.tracker.errorTitle": "Errore nel Caricamento dei Dati",
  "admin.commissions.tracker.errorMessage": "Impossibile caricare i dati del tracciamento commissioni",
  "admin.commissions.tracker.retryButton": "Riprova",

  // Tracker filters section
  "admin.commissions.tracker.filters.title": "Filtri",
  "admin.commissions.tracker.filters.ancestorUsername": "Nome Utente Antenato",
  "admin.commissions.tracker.filters.ancestorUsernamePlaceholder": "Inserisci nome utente antenato",
  "admin.commissions.tracker.filters.referralUsername": "Nome Utente Referral",
  "admin.commissions.tracker.filters.referralUsernamePlaceholder": "Inserisci nome utente referral",
  "admin.commissions.tracker.filters.accountNumber": "Numero di Conto",
  "admin.commissions.tracker.filters.accountNumberPlaceholder": "Inserisci numero di conto",
  "admin.commissions.tracker.filters.level": "Livello",
  "admin.commissions.tracker.filters.levelPlaceholder": "Seleziona livello",
  "admin.commissions.tracker.filters.allLevels": "Tutti i Livelli",
  "admin.commissions.tracker.filters.leftoverCommission": "Commissione Residua",
  "admin.commissions.tracker.filters.leftoverCommissionPlaceholder": "Seleziona commissione residua",
  "admin.commissions.tracker.filters.allLeftover": "Tutti",
  "admin.commissions.tracker.filters.leftoverYes": "Sì",
  "admin.commissions.tracker.filters.leftoverNo": "No",
  "admin.commissions.tracker.filters.period": "Periodo",
  "admin.commissions.tracker.filters.dateFrom": "Da Data",
  "admin.commissions.tracker.filters.dateTo": "A Data",
  "admin.commissions.tracker.filters.commissionAmount": "Importo Commissione",
  "admin.commissions.tracker.filters.commissionMin": "Commissione Min",
  "admin.commissions.tracker.filters.commissionMinPlaceholder": "Importo minimo",
  "admin.commissions.tracker.filters.commissionMax": "Commissione Max",
  "admin.commissions.tracker.filters.commissionMaxPlaceholder": "Importo massimo",
  "admin.commissions.tracker.filters.profitAmount": "Importo Profitto",
  "admin.commissions.tracker.filters.profitMin": "Profitto Min",
  "admin.commissions.tracker.filters.profitMinPlaceholder": "Profitto minimo",
  "admin.commissions.tracker.filters.profitMax": "Profitto Max",
  "admin.commissions.tracker.filters.profitMaxPlaceholder": "Profitto massimo",
  "admin.commissions.tracker.filters.applyFilters": "Applica Filtri",
  "admin.commissions.tracker.filters.clearFilters": "Cancella Filtri",

  // Tracker table section
  "admin.commissions.tracker.table.title": "Tracciamento Commissioni",
  "admin.commissions.tracker.table.ancestorUsername": "Antenato",
  "admin.commissions.tracker.table.ancestorName": "Nome Antenato",
  "admin.commissions.tracker.table.referralUsername": "Referral",
  "admin.commissions.tracker.table.referralName": "Nome Referral",
  "admin.commissions.tracker.table.accountNumber": "N. Conto",
  "admin.commissions.tracker.table.period": "Periodo",
  "admin.commissions.tracker.table.leftover": "Residua",
  "admin.commissions.tracker.table.leftoverYes": "Sì",
  "admin.commissions.tracker.table.leftoverNo": "No",
  "admin.commissions.tracker.table.level": "Livello",
  "admin.commissions.tracker.table.levelCompany": "Azienda",
  "admin.commissions.tracker.table.levelLeftover": "Residuo",
  "admin.commissions.tracker.table.commissionPercentage": "Percentuale",
  "admin.commissions.tracker.table.commissionAmount": "Importo Commissione",
  "admin.commissions.tracker.table.profitAmount": "Importo Profitto",
  "admin.commissions.tracker.table.noData": "Nessun dato di tracciamento commissioni trovato",
  "admin.commissions.tracker.table.error": "Errore nel caricamento dei dati di tracciamento commissioni",
  "admin.commissions.tracker.table.showing": "Mostrando",
  "admin.commissions.tracker.table.of": "di",
  "admin.commissions.tracker.table.records": "record",

  // Profits page translations
  "admin.commissions.profits.title": "Profitti da Commissioni",
  "admin.commissions.profits.subtitle": "Visualizzare e analizzare la cronologia dei profitti da commissioni",
  "admin.commissions.profits.errorTitle": "Errore nel Caricamento dei Dati",
  "admin.commissions.profits.errorMessage": "Impossibile caricare i dati dei profitti da commissioni",
  "admin.commissions.profits.retryButton": "Riprova",

  // Profits filters section
  "admin.commissions.profits.filters.title": "Filtri",
  "admin.commissions.profits.filters.user": "Utente",
  "admin.commissions.profits.filters.userPlaceholder": "Inserisci nome utente",
  "admin.commissions.profits.filters.period": "Periodo",
  "admin.commissions.profits.filters.dateFrom": "Da Data",
  "admin.commissions.profits.filters.dateTo": "A Data",
  "admin.commissions.profits.filters.commissionAmount": "Importo della Commissione",
  "admin.commissions.profits.filters.commissionMin": "Commissione Min",
  "admin.commissions.profits.filters.commissionMinPlaceholder": "Importo minimo",
  "admin.commissions.profits.filters.commissionMax": "Commissione Max",
  "admin.commissions.profits.filters.commissionMaxPlaceholder": "Importo massimo",
  "admin.commissions.profits.filters.leftoverCommission": "Commissione Residua",
  "admin.commissions.profits.filters.leftoverCommissionPlaceholder": "Seleziona commissione residua",
  "admin.commissions.profits.filters.allLeftover": "Tutti",
  "admin.commissions.profits.filters.leftoverYes": "Sì",
  "admin.commissions.profits.filters.leftoverNo": "No",
  "admin.commissions.profits.filters.applyFilters": "Applica Filtri",
  "admin.commissions.profits.filters.clearFilters": "Cancella Filtri",

  // Profits table section
  "admin.commissions.profits.table.title": "Profitti da Commissioni",
  "admin.commissions.profits.table.username": "Nome utente",
  "admin.commissions.profits.table.name": "Nome",
  "admin.commissions.profits.table.period": "Periodo",
  "admin.commissions.profits.table.commissionAmount": "Importo Commissione",
  "admin.commissions.profits.table.leftover": "Residuo",
  "admin.commissions.profits.table.leftoverYes": "Sì",
  "admin.commissions.profits.table.leftoverNo": "No",
  "admin.commissions.profits.table.noData": "Nessun dato commissione trovato",
  "admin.commissions.profits.table.error": "Errore nel caricamento dei dati commissione",
  "admin.commissions.profits.table.showing": "Mostrando",
  "admin.commissions.profits.table.of": "di",
  "admin.commissions.profits.table.records": "record",

  // Totals page translations
  "admin.commissions.totals.title": "Totali Commissioni",
  "admin.commissions.totals.subtitle": "Visualizza e analizza i guadagni totali delle commissioni per utente",
  "admin.commissions.totals.errorTitle": "Errore nel Caricamento dei Dati",
  "admin.commissions.totals.errorMessage": "Impossibile caricare i dati dei totali delle commissioni",
  "admin.commissions.totals.retryButton": "Riprova",

  // Totals filters section
  "admin.commissions.totals.filters.title": "Filtri",
  "admin.commissions.totals.filters.user": "Utente",
  "admin.commissions.totals.filters.userPlaceholder": "Inserisci nome utente",
  "admin.commissions.totals.filters.commissionAmount": "Importo Commissione",
  "admin.commissions.totals.filters.commissionMin": "Commissione Min",
  "admin.commissions.totals.filters.commissionMinPlaceholder": "Importo minimo",
  "admin.commissions.totals.filters.commissionMax": "Commissione Max",
  "admin.commissions.totals.filters.commissionMaxPlaceholder": "Importo massimo",
  "admin.commissions.totals.filters.applyFilters": "Applica Filtri",
  "admin.commissions.totals.filters.clearFilters": "Cancella Filtri",

  // Totals table section
  "admin.commissions.totals.table.title": "Totali Commissioni",
  "admin.commissions.totals.table.username": "Nome Utente",
  "admin.commissions.totals.table.name": "Nome",
  "admin.commissions.totals.table.totalCommission": "Commissioni Totali",
  "admin.commissions.totals.table.lastUpdate": "Ultimo Aggiornamento",
  "admin.commissions.totals.table.noData": "Nessun dato sui totali delle commissioni trovato",
  "admin.commissions.totals.table.error": "Errore nel caricamento dei dati dei totali delle commissioni",
  "admin.commissions.totals.table.showing": "Mostrando",
  "admin.commissions.totals.table.of": "di",
  "admin.commissions.totals.table.records": "record",

  // Balances page translations
  "admin.commissions.balances.title": "Saldi Commissioni",
  "admin.commissions.balances.subtitle": "Visualizza e gestisci i dati del saldo delle commissioni per tutti gli utenti",
  "admin.commissions.balances.errorTitle": "Errore nel Caricamento dei Dati",
  "admin.commissions.balances.errorMessage": "Impossibile caricare i dati dei saldi delle commissioni",
  "admin.commissions.balances.retryButton": "Riprova",

  // Balances filters section
  "admin.commissions.balances.filters.title": "Filtri",
  "admin.commissions.balances.filters.user": "Utente",
  "admin.commissions.balances.filters.userPlaceholder": "Inserisci nome utente",
  "admin.commissions.balances.filters.balanceAmount": "Importo Saldo",
  "admin.commissions.balances.filters.balanceMinPlaceholder": "Importo minimo",
  "admin.commissions.balances.filters.balanceMaxPlaceholder": "Importo massimo",
  "admin.commissions.balances.filters.paidAmount": "Importo Pagato",
  "admin.commissions.balances.filters.paidMinPlaceholder": "Minimo pagato",
  "admin.commissions.balances.filters.paidMaxPlaceholder": "Massimo pagato",
  "admin.commissions.balances.filters.applyFilters": "Applica Filtri",
  "admin.commissions.balances.filters.clearFilters": "Cancella Filtri",

  // Balances table section
  "admin.commissions.balances.table.title": "Saldi Commissioni",
  "admin.commissions.balances.table.username": "Nome Utente",
  "admin.commissions.balances.table.name": "Nome",
  "admin.commissions.balances.table.currentBalance": "Saldo Corrente",
  "admin.commissions.balances.table.totalPaid": "Totale Pagato",
  "admin.commissions.balances.table.lastUpdate": "Ultimo Aggiornamento",
  "admin.commissions.balances.table.noData": "Nessun dato di saldo commissioni trovato",
  "admin.commissions.balances.table.error": "Errore nel caricamento dei dati di saldo commissioni",
  "admin.commissions.balances.table.loading": "Caricamento...",
  "admin.commissions.balances.table.showing": "Mostrando",
  "admin.commissions.balances.table.of": "di",
  "admin.commissions.balances.table.records": "record",

  // Payments page translations
  "admin.commissions.payments.title": "Pagamenti Commissioni",
  "admin.commissions.payments.subtitle": "Traccia e gestisci lo storico dei pagamenti delle commissioni",
  "admin.commissions.payments.errorTitle": "Errore nel Caricamento Pagamenti",
  "admin.commissions.payments.errorMessage": "Impossibile caricare i dati dei pagamenti delle commissioni",
  "admin.commissions.payments.retryButton": "Riprova",

  // Payments filters section
  "admin.commissions.payments.filters.title": "Filtri",
  "admin.commissions.payments.filters.user": "Nome Utente",
  "admin.commissions.payments.filters.userPlaceholder": "Inserisci nome utente",
  "admin.commissions.payments.filters.dateFrom": "Data Pagamento Da",
  "admin.commissions.payments.filters.dateTo": "Data Pagamento A",
  "admin.commissions.payments.filters.paymentAmountMin": "Importo Minimo Pagamento",
  "admin.commissions.payments.filters.paymentAmountMinPlaceholder": "Importo minimo",
  "admin.commissions.payments.filters.paymentAmountMax": "Importo Massimo Pagamento",
  "admin.commissions.payments.filters.paymentAmountMaxPlaceholder": "Importo massimo",
  "admin.commissions.payments.filters.paymentStatus": "Stato Pagamento",
  "admin.commissions.payments.filters.paymentStatusPlaceholder": "Seleziona stato",
  "admin.commissions.payments.filters.allStatuses": "Tutti gli Stati",
  "admin.commissions.payments.filters.applyFilters": "Applica Filtri",
  "admin.commissions.payments.filters.clearFilters": "Cancella Filtri",

  // Payments table section
  "admin.commissions.payments.table.title": "Pagamenti Commissioni",
  "admin.commissions.payments.table.username": "Nome Utente",
  "admin.commissions.payments.table.name": "Nome",
  "admin.commissions.payments.table.paymentAmount": "Importo Pagamento",
  "admin.commissions.payments.table.feeAmount": "Importo Commissione",
  "admin.commissions.payments.table.netAmount": "Importo Netto",
  "admin.commissions.payments.table.paymentDate": "Data Pagamento",
  "admin.commissions.payments.table.paymentStatus": "Stato",
  "admin.commissions.payments.table.paymentAccount": "Conto Pagamento",
  "admin.commissions.payments.table.noData": "Nessun record di pagamento trovato",
  "admin.commissions.payments.table.error": "Errore nel caricamento dei dati di pagamento",
  "admin.commissions.payments.table.showing": "Mostrando",
  "admin.commissions.payments.table.of": "di",
  "admin.commissions.payments.table.records": "record",
  
  // Payment status translations
  "admin.commissions.payments.status.pending": "In Attesa",
  "admin.commissions.payments.status.paid": "Pagato",
  "admin.commissions.payments.status.completed": "Completato",
  "admin.commissions.payments.status.cancelled": "Annullato",
  "admin.commissions.payments.status.failed": "Fallito",
  "admin.commissions.payments.status.rejected": "Rifiutato",

  // Models page translations
  "admin.commissions.models.title": "Modelli di Commissione",
  "admin.commissions.models.subtitle": "Visualizza e gestisci tutti i modelli di commissione disponibili",
  "admin.commissions.models.errorTitle": "Errore nel Caricamento dei Dati",
  "admin.commissions.models.errorMessage": "Impossibile caricare i modelli di commissione",
  "admin.commissions.models.retryButton": "Riprova",
  "admin.commissions.models.loading": "Caricamento modelli di commissione...",

  // Models card translations
  "admin.commissions.models.card.name": "Nome",
  "admin.commissions.models.card.description": "Descrizione",
  "admin.commissions.models.card.maxLevels": "Livelli Massimi",
  "admin.commissions.models.card.createdAt": "Creato il",
  "admin.commissions.models.card.updatedAt": "Aggiornato il",
  "admin.commissions.models.card.levelTable.title": "Livelli di Commissione",
  "admin.commissions.models.card.levelTable.level": "Livello",
  "admin.commissions.models.card.levelTable.percentage": "Percentuale",
  "admin.commissions.models.card.noLevels": "Nessun livello di commissione definito",

  // Manager page translations
  "admin.commissions.manager.title": "Gestore Commissioni",
  "admin.commissions.manager.subtitle": "Calcolare e gestire l'elaborazione mensile delle commissioni",
  "admin.commissions.manager.form.title": "Calcolo Commissioni Mensili",
  "admin.commissions.manager.form.description": "Seleziona il mese target per elaborare le commissioni",
  "admin.commissions.manager.form.periodLabel": "Periodo Target",
  "admin.commissions.manager.form.periodHint": "Formato: yyyy-mm-01 (es.",
  "admin.commissions.manager.form.periodFormatError": "Il periodo deve essere nel formato yyyy-mm-01",
  "admin.commissions.manager.form.calculateButton": "Calcola Commissioni",
  "admin.commissions.manager.form.calculating": "Calcolo in corso...",
  "admin.commissions.manager.results.title": "Risultati Calcolo Commissioni",
  "admin.commissions.manager.results.description": "Risultati per il mese di elaborazione",
  "admin.commissions.manager.results.processingMonth": "Mese di Elaborazione",
  "admin.commissions.manager.results.totalWorkers": "Totale Lavoratori",
  "admin.commissions.manager.results.processingDuration": "Tempo di Elaborazione",
  "admin.commissions.manager.results.totalProcessed": "Record Elaborati",
  "admin.commissions.manager.results.totalFailed": "Record Falliti",
  "admin.commissions.manager.results.successRate": "Tasso di Successo",
  "admin.commissions.manager.results.totalCommissionAmount": "Importo Totale Commissioni",
  "admin.commissions.manager.results.totalLeftoverAmount": "Importo Totale Rimanente",
  "admin.commissions.manager.logs.title": "Log Elaborazione Commissioni",
  "admin.commissions.manager.logs.description": "Visualizza log dettagliati per i calcoli delle commissioni",
  "admin.commissions.manager.logs.filterLabel": "Filtra per Mese",
  "admin.commissions.manager.logs.searchButton": "Cerca",
  "admin.commissions.manager.logs.clearButton": "Cancella",
  "admin.commissions.manager.logs.showing": "Mostrando",
  "admin.commissions.manager.logs.records": "record",
  "admin.commissions.manager.logs.noLogs": "Nessun log di commissioni trovato",
  "admin.commissions.manager.logs.table.month": "Mese",
  "admin.commissions.manager.logs.table.workerId": "ID Lavoratore",
  "admin.commissions.manager.logs.table.status": "Stato",
  "admin.commissions.manager.logs.table.processed": "Elaborati",
  "admin.commissions.manager.logs.table.failed": "Falliti",
  "admin.commissions.manager.logs.table.commissionAmount": "Importo Commissione",
  "admin.commissions.manager.logs.table.leftoverAmount": "Importo Rimanente",
  "admin.commissions.manager.logs.table.startedAt": "Iniziato alle",
  "admin.commissions.manager.logs.table.completedAt": "Completato alle",
  "admin.commissions.manager.logs.table.duration": "Durata",
  "admin.commissions.manager.error.title": "Errore nell'Elaborazione delle Commissioni",
  "admin.commissions.manager.error.message": "Si è verificato un errore durante l'elaborazione delle commissioni"
};
